// extracted by mini-css-extract-plugin
module.exports = {"close-button":"close-button_close-button__2bfYX","close-button-wrapper":"close-button_close-button-wrapper__3SKkl","warning-text":"close-button_warning-text__1oJkO"};